// 店舗データ API URL（shoplist / shoplist-detail 共通）

//window.shopListConfig = {
//  apiUrl:
//    'https://script.google.com/macros/s/AKfycbzHg6hUZlgvxyZEjqxLYNaO22sq1hwpO_iAQ1e_eVdTkh1SRlbgdarQaZdUzFIao4p1/exec',
//};
window.shopListConfig = {
  apiUrl: 'https://storage.googleapis.com/yvesrocher-shop/stores.json',
};
